module.exports = __webpack_public_path__ + "images/bar-chart-icon.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/bar-chart-icon.png
// module id = 203
// module chunks = 0